import { render, staticRenderFns } from "./majorCourse.vue?vue&type=template&id=4ede0986&scoped=true&"
import script from "./majorCourse.vue?vue&type=script&lang=js&"
export * from "./majorCourse.vue?vue&type=script&lang=js&"
import style0 from "./majorCourse.vue?vue&type=style&index=0&id=4ede0986&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ede0986",
  null
  
)

export default component.exports